import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { slideHtmlStyles } from 'src/content/screens/slide-html-styles';
import { styleMap } from 'lit/directives/style-map.js';

@customElement('d-view-html-for-slide')
export class DViewHtmlForSlide extends LitElement {
  static readonly styles = [
    slideHtmlStyles,
    css`
      .wireframe-text {
        display: flex;
        flex-direction: column;
        gap: 2.5cqw;
        padding: 2cqw 6cqw 6cqw 6cqw;
      }
      .wireframe-text.header {
        justify-content: flex-end;
        gap: 3cqw;
        padding-top: 6cqw;
        padding-bottom: 2cqw;
      }
      .wireframe-text div {
        flex-shrink: 0;
        height: 2cqw;
        background: black;
        opacity: 0.3;
      }
      .wireframe-text.header div {
        height: 4cqw;
      }
      .wireframe-text[text-align='center'] {
        align-items: center;
      }
      .wireframe-text[text-align='right'] {
        align-items: flex-end;
      }
      .wireframe-text[text-color='white'] div {
        background: white;
        opacity: 0.5;
      }
      #content {
        user-select: none;
      }
    `,
  ];
  @property({ type: String, attribute: 'layout-position', reflect: true })
  layoutPosition: 'full' | 'top' | 'right' | 'bottom' | 'left' = 'full';
  @property({ type: Boolean })
  wireframe = false;
  @property({ type: String })
  value = '';
  @property({ type: Boolean, reflect: true })
  header = false;
  @property({ type: String })
  textColor = 'black';
  @property({ type: String, attribute: 'text-align', reflect: true })
  textAlign = 'left';

  private get low() {
    return this.layoutPosition === 'top' || this.layoutPosition === 'bottom';
  }

  private get styles() {
    return {
      color: this.textColor,
    };
  }

  private renderWireframeText() {
    if (this.header) {
      return html` <div
        class="wireframe-text header"
        text-color="${this.textColor ?? 'black'}"
        text-align="${this.textAlign ?? 'left'}"
      >
        <div style="width: 70%"></div>
        ${!this.low ? html` <div style="width: 90%"></div> ` : nothing}
      </div>`;
    }
    return html` <div
      class="wireframe-text"
      text-color="${this.textColor ?? 'black'}"
      text-align="${this.textAlign ?? 'left'}"
    >
      <div style="width: 60%"></div>
      <div style="width: 90%"></div>
      ${!this.low ? html` <div style="width: 40%"></div> ` : nothing}
    </div>`;
  }

  render() {
    if (this.wireframe) {
      return this.renderWireframeText();
    }
    return html` <div id="content" class="html" style=${styleMap(this.styles)}>${unsafeHTML(this.value)}</div> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-view-html-for-slide': DViewHtmlForSlide;
  }
}
